var _style, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF5LogoBlackFull01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 548 145.4",
    style: {
      enableBackground: "new 0 0 548 145.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B61EE;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.4,29.3c-3-3.4-7.4-5.3-11.9-5.2c-2.3,0-4.5,0.5-6.6,1.4l1.9-10.3h15l2.8-6.2h-23.2l-4.7,24.7l5.2,1.8 l0.4-0.5c2.5-3.2,5.4-4.8,8.9-4.8c2.8-0.1,5.6,1.2,7.4,3.3c1.9,2.2,3,5,2.9,7.9c0.1,3-1,6-3.2,8.2c-2,2.1-4.7,3.2-7.5,3.1 c-2.6-0.1-5-1.2-6.8-3.1c-2-1.8-3.1-4.4-3.1-7.2v-1h-6.7l0.1,1c0.3,4.4,2.2,8.6,5.4,11.7s7.5,4.7,12,4.6c4.4,0,8.7-1.8,11.7-5.1 c3.2-3.3,4.9-7.8,4.8-12.4C538.2,37,536.5,32.6,533.4,29.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.5,50.7h-0.3c-5.4-10.8-17.5-16.1-29.5-16.1c-11.2-0.3-22,4.2-29.7,12.5c-7,7.1-10.9,16.7-11,26.7 c0,11.5,4.7,21.1,7.5,24.2c9.7,11.1,22.1,16.1,33.5,16.1c12,0,23.6-5.4,29.2-16.1h0.3v14.3h9.9V36.2h-9.9V50.7z M109,104.2 c-16.3,0-30.7-12.9-30.7-29.6c0.1-16.7,13.7-30.3,30.4-30.2c0,0,0,0,0.1,0c17,0,29.8,13.5,29.8,30.3 C138.5,90.6,124.9,104.2,109,104.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.3,44.4c10.6,0.1,20.4,5.8,25.9,14.9h11.5c-5.8-15.3-21.4-24.8-37.6-24.8c-22,0-41.2,17.1-41.2,39.6 c0,23.2,18.9,39.9,41.6,39.9c16.4,0,30.2-9.2,37-24.1h-11.4c-6.7,9.3-14.9,14.2-26.7,14.2c-16.5,0.2-30-13.1-30.2-29.6 c0-0.2,0-0.4,0-0.6C173.3,56.9,187.5,44.4,204.3,44.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.1,34.5c-22.1,0-40,18-39.9,40.1v0.1c0,21.8,18.4,39.4,39.9,39.4c22,0,39.5-18.6,39.5-40.3 C393.6,52.6,375.3,34.5,354.1,34.5z M354.1,104.2c-16.3,0-29.6-13.2-29.6-29.5c0-16.5,12.8-30.3,29.6-30.3 c7.6,0.1,14.8,3.1,20.3,8.3c5.9,5.4,9.1,13,8.9,21C383.4,90.3,371.1,104.2,354.1,104.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418,47.2h-0.3v-11H408v76.1h10.3V69.7c0-8.6,0.7-13.8,7.8-19.8c4.3-3.6,8.2-4.9,13.8-5.3V34.5 C430.6,34.8,421.8,38.1,418,47.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "5.3,112.3 15.6,112.3 15.6,65.3 51.5,65.3 55.9,56 15.6,56 15.6,18.8 56.4,18.8 56.4,9.5 5.3,9.5 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.2,85.4c0,12.9,0.2,15.4,1,18.9c2,8.4,10.4,9.9,17.9,9.9c3.1,0,6.1-0.2,9.2-0.7v-9 c-2.3,0.3-4.6,0.5-6.9,0.5c-11.2,0-10.9-5.7-10.9-14.4V45.5h13.3l4.4-9.3h-17.7V9.5h-10.3v26.7h-15.9v9.3h15.9V85.4z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "500,64 485.8,96.9 461.5,36.2 450.5,36.2 479.7,109.9 467.8,139 478.6,139 511,64 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF5LogoBlackFull01);
export default __webpack_public_path__ + "static/media/F5_logo_black_full-01.907880d546ad5eaa1ff98ce014bb4eec.svg";
export { ForwardRef as ReactComponent };